import React, { useCallback, useContext } from 'react';
import DreamIcon from '@wix/da-ds/pkg/Icons/24x24/EditorDream';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openMuro } from '../../../redux/actions/editor';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import EditorIconButton from '../_partials/EditorIconButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const Dream = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const dispatch = useDispatch();
    const isMicroMuro = useFlag('micro_muro');
    const isMobile = useContext(MobileContext);
    const onOpenMuro = useCallback(()=>{
        const { from, to } = editor.state.selection;
        const selectedText = editor.state.doc.textBetween(from, to, ' ');
        if (selectedText === '') {
            return false;
        }
        editor.commands.setTextSelection(0);
        dispatch(openMuro({
            initialPrompt: selectedText
        }));
    }, [
        dispatch,
        editor.commands,
        editor.state.doc,
        editor.state.selection
    ]);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'muro') || !isMicroMuro || isMobile) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: DreamIcon,
        onClick: onOpenMuro,
        tooltipText: t('button.dream.tooltip'),
        "aria-label": t('button.dream.tooltip')
    });
};
Dream.displayName = 'Dream';
export default Dream;

//# sourceMappingURL=Dream.js.map